import commonDictionary from '../../ru/common.dic.json';

export const commonNS = {
  COMMON: commonDictionary,
};

export const commonNamespaces = ['COMMON'];
